<template>
    <div style="width:100%;height:100%;margin:0;padding:0;">
        <tui-image-editor class="fusion-tui-image-editor-main-wrapper"  @hook:mounted="tuiImageEditorMounted()" :include-ui="useDefaultUI" ref="tuiImageEditor" :options="options"></tui-image-editor>
    </div>
</template>

<script>
import 'tui-color-picker/dist/tui-color-picker.css';
import 'tui-image-editor/dist/tui-image-editor.css';
import { ImageEditor } from '@toast-ui/vue-image-editor';
export default {
   name:'Fusion-Image_Editor',
   components:{'tui-image-editor':ImageEditor},
   props:['options','useDefaultUI'],
   methods:{
       tuiImageEditorMounted(){
           this.$emit('TUIimageEditorMounted');
       },
       invoke(params){
          return this.$refs.tuiImageEditor.invoke(params);
       }
   }
}
</script>
